import { useContext } from 'react'

import { NavigationContext } from '../contexts'

export const useNavigationContext = () => {
  const context = useContext(NavigationContext)
  return { ...context }
}
